module.exports = __webpack_public_path__ + "img/case-tab-bg-03.f449dfc1.jpg";